module.exports = __webpack_public_path__ + "bba6140a35abc31af64b3470c830d2c4.svg";